import { Typography, withStyles } from '@material-ui/core';
import MenuFiltro from 'app/Core/Components/MenuFiltro/MenuFiltro';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import React from "react";

const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: 8,
    },
    item: {
        height: 40,
        borderRadius: '0 20px 20px 0',
        paddingRight: 12,
        '&.active': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText + '!important',
            transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
            '& .list-item-text-primary': {
                color: 'inherit'
            },
            '& .list-item-icon': {
                color: 'inherit'
            }
        },
        '&.square, &.active.square': {
            width: '100%',
            borderRadius: '0'
        },
        '& .list-item-icon': "folder",
        '& .list-item-text': {},
        color: theme.palette.text.primary,
        textDecoration: 'none!important'
    }
});

class EmpresaFinanceiroSidebar extends XAPPComponent {

    render() {
        const { classes, EmpresaFinanceiro, setCondicoes, filtros } = this.props;

        return (
            <div className="flex-auto border-l-1 border-solid">
                <Typography className="pr-24 pl-16 pt-12" disableSticky>Filtros</Typography>
                {filtros.includes(7) &&
                    <MenuFiltro
                        nome={"Natureza"}
                        data={EmpresaFinanceiro.data}
                        campo={"naturezadescricao"}
                        setCondicoes={setCondicoes}
                    />
                }
                {filtros.includes(1) &&
                    <MenuFiltro
                        nome={"Status"}
                        data={EmpresaFinanceiro.data}
                        campo={"status"}
                        setCondicoes={setCondicoes}
                    />
                }
                {filtros.includes(2) &&
                    <MenuFiltro
                        nome={"Operador"}
                        data={EmpresaFinanceiro.caixas}
                        campo={"responsavelnome"}
                        setCondicoes={setCondicoes}
                    />
                }
                {filtros.includes(3) &&
                    <MenuFiltro
                        nome={"Status"}
                        data={EmpresaFinanceiro.faturamento}
                        campo={"status"}
                        setCondicoes={setCondicoes}
                    />
                }
                {filtros.includes(4) &&
                    <MenuFiltro
                        nome={"Natureza"}
                        data={EmpresaFinanceiro.extrato}
                        campo={"naturezadescricao"}
                        setCondicoes={setCondicoes}
                    />
                }
                {filtros.includes(5) &&
                    <MenuFiltro
                        nome={"Forma de pagamento"}
                        data={EmpresaFinanceiro.data}
                        campo={"idpessoaformularioformapagamentodescricao"}
                        setCondicoes={setCondicoes}
                    />
                }
                {filtros.includes(6) &&
                    <MenuFiltro
                        nome={"Categoria"}
                        data={EmpresaFinanceiro.extrato}
                        campo={"idpessoaformulariocategoriadescricao"}
                        setCondicoes={setCondicoes}
                    />
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // save: Actions.save
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroSidebar)));
